module.exports = __webpack_public_path__ + "static/media/logo-miguelleao.97289ce0.png";